<template>
  <v-runtime-template :template="includeTemplate"/>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import wepHtmlToString from '@/plugins/_common/WepHtmlToString'
import { isEmpty } from 'lodash'

export default {
  name: 'PanoptoSsoProc',
  metaInfo () {
  },
  components: {
    VRuntimeTemplate
  },
  data () {
    return {
      includeHtml: '',
      basePath: this.getStore('mmpAuth').state.basePath,
      ptptConfmMsg: ''
    }
  },
  computed: {
    includeTemplate () {
      return this.includeHtml
    }
  },
  watch: {
    // 'mbrFnm': {
    //   handler: function (newVal, oldVal) {
    //     if (isEmpty(this.newVal) && this.loginErr) {
    //       this.loginErr = false
    //     }
    //   }
    // }
  },
  beforeUpdate () {
  },
  updated () {
  },
  async created () {
    if (isEmpty(wepHtmlToString.mainTemplate)) {
      this.getEmptyTemplate('wepPtptConfm.html')
    } else {
      this.includeHtml = wepHtmlToString.mainTemplate
    }
    this.fnSsoLogin()
  },
  methods: {
    getEmptyTemplate (resourceUrl) {
      resourceUrl = this.getTemplatePath(resourceUrl)
      this.$http.loadRes(resourceUrl).then( (res) => {
        wepHtmlToString.mainTemplate = res
        this.includeHtml = wepHtmlToString.mainTemplate
      })
    },
    openNotice () {
      document.querySelectorAll('.notice-item')[0].classList.toggle('opened')
    },
    async fnSsoLogin () {
      let params = {
        token: this.$route.params.token,
        wepId: this.getStore('mmpAuth').state.saveId
      }
      await this.$http.mmp.panoptoSsoProc(this, params)
      // await this.$http.mmp.memberInfo(this, params)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/contents/main/PanoptoSsoProc.vue